import { Attribute, Component, Injector, Optional, TemplateRef } from "@angular/core";
import {APPLY_STYLES_TYPE, getWidgetRegistry, Parent, register, StylableComponent, styler} from "@wm/components-base";
import { CommonModule } from "@angular/common";
import { ListItemDirective } from "./list-item.directive";
import { BasicPagination } from "../basic-pagination/basic-pagination.component";
import { runtimeEventManager, switchClass } from "@wm/core";
import { WmsTranscludeDirective } from "../../page/wms-transclude/wms-transclude.directive";
import { setListClass } from "../../formWidgetUtils";
import {get, includes, split, startsWith} from "lodash-es";


const DEFAULT_CLS = 'app-livelist app-panel';
const WIDGET_CONFIG = { widgetType: 'wm-list', hostClass: DEFAULT_CLS };
export const NAVIGATION_TYPE = {
  ADVANCED: 'Advanced',
  BASIC: 'Basic',
  CLASSIC: 'Classic',
  INLINE: 'Inline',
  NONE: 'None',
  ONDEMAND: 'On-Demand',
  PAGER: 'Pager',
  SCROLL: 'Scroll'
};
@Component({
  selector: '[wmList]',
  standalone: true,
  imports: [CommonModule, ListItemDirective, BasicPagination, WmsTranscludeDirective],
  styles: ['.app-livelist-container { padding: 0px; }'],
  template: `<div class="panel-heading" *ngIf="title || subheading || iconclass">
    <h3 class="panel-title">
      <div class="pull-left">
        <i class="app-icon panel-icon {{iconclass}}" aria-hidden="true" [hidden]="!iconclass"></i>
      </div>
      <div class="pull-left">
        <div class="heading" [innerHTML]="title"></div>
        <div class="description" [innerHTML]="subheading"></div>
      </div>
    </h3>
  </div>

  <nav class="app-datanavigator" aria-label="Page navigation" *ngIf="navigation === 'Inline' && !noDataFound">
    <ul class="pager">
        <li class="previous" [ngClass]="{'disabled': (dataNavigator ? dataNavigator.isDisablePrevious : true)}">
            <a href="javascript:void(0);" (click)="dataNavigator.navigatePage('prev', $event)">
                <i class="wi wi-chevron-left" aria-hidden="true"></i>
                <span class="sr-only">Previous</span>
            </a>
        </li>
    </ul>
  </nav>
<!-- *ngIf onDataFound is having issue in rendering the template when dataset is comma separated string. Hence removed it. even hidden was not working correctly -->
<ul data-identifier="list" tabindex="0" class="app-livelist-container clearfix {{direction === 'horizontal' ? 'app-horizontal-list': ''}} {{listclass}}" wmsTransclude>
  <ng-content></ng-content>
</ul>

<nav class="app-datanavigator" *ngIf="navigation === 'Inline' && !noDataFound">
    <ul class="pager">
        <li class="next" [ngClass]="{'disabled': (dataNavigator ? dataNavigator.isDisableNext  : true)}">
            <a href="javascript:void(0);" (click)="dataNavigator.navigatePage('next', $event)">
                <i class="wi wi-chevron-right" aria-hidden="true"></i>
                <span class="sr-only">Next</span>
            </a>
        </li>
    </ul>
</nav>

<div class="panel-footer" *ngIf="navigation !== 'None' && !isNativeApplicationType" [hidden]="!showNavigation">
    <nav wmPagination
         navigationalign.bind="navigationalign"
         navigation.bind="navControls"
         showrecordcount.bind="showrecordcount"
         maxsize.bind="maxsize"
         boundarylinks.bind="boundarylinks"
         forceellipses.bind="forceellipses"
         directionlinks.bind="directionlinks"
         show.bind="!onDemandLoad"
         paginationchange.event="beforePaginationChange($event, $index)"
    ></nav>
    <basicPagination
        [navigationAlign]="navigationalign"
        [navigationType]="navigation"
        [dataset]="dataset"
        [showrecordcount]="showrecordcount"
        [currentPage]="currentPage"></basicPagination>
    <a *ngIf="onDemandLoad" href="javascript:void(0);"
       (click)="dataNavigator.navigatePage('next', $event)"
       class="app-button btn btn-block"
       [ngClass]="paginationclass"
       [textContent]="ondemandmessage"
    ></a>
</div>
`
})
export class ListComponent extends StylableComponent {
  static initializeProps = register('wm-list');

  public title: string;
  public subheading: string;
  public iconclass: string;
  public dataNavigator: any;
  public navigation: string;
  public noDataFound: boolean;
  public groupby: string;
  public direction: string
  public itemsPerRowClass: string
  listTemplate: TemplateRef<any>;
  showNavigation: boolean;
  navControls: any;
  infScroll: any;
  allowpagesizechange: boolean;
  onDemandLoad: boolean;
  public navigationalign: string;
  public pagesize: number;
  public dataset: any;
  public paginationclass: string;
  public ondemandmessage: string;
  public currentPage: any;
  showrecordcount: any;
  private binddatasource: string;
  private datasource: any;
  listclass: any;
  liveWidgetUtils: any;
  isNativeApplicationType : boolean = false;

  constructor(inj: Injector,
    @Optional() viewParent: Parent,
    @Attribute('dataset.bind') binddataset: string) {
    super(inj, WIDGET_CONFIG, viewParent);
    this.noDataFound = !binddataset;
    this.liveWidgetUtils = runtimeEventManager.getService('LiveWidgetUtilsService');
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.SHELL);
    const projectService = runtimeEventManager.getService('projectService');
    this.isNativeApplicationType  = projectService.isNativeMobileApplicationType()
    if(this.isNativeApplicationType && binddataset){
      this.handlePageSizeDisplay(binddataset.split('.')[1]);
    }
  }

  override ngAfterViewInit(): void {
    const $ul = this.nativeElement.querySelector('ul.app-livelist-container');
    styler($ul as HTMLElement, this, APPLY_STYLES_TYPE.SCROLLABLE_CONTAINER);
    // TODO: apply scrollable type based on height
    setListClass(this);
    $(this.nativeElement).find('.app-list-item').addClass(this.itemsPerRowClass);
  }

  private resetNavigation() {
    this.showNavigation = false;
    this.navControls = undefined;
    this.infScroll = false;
    this.onDemandLoad = false;
  }

  private enableBasicNavigation() {
    this.navControls = NAVIGATION_TYPE.BASIC;
    this.showNavigation = true;
  }

  private enableInlineNavigation() {
    this.navControls = NAVIGATION_TYPE.INLINE;
  }

  private enableClassicNavigation() {
    this.navControls = NAVIGATION_TYPE.CLASSIC;
    this.showNavigation = true;
  }

  private enablePagerNavigation() {
    this.navControls = NAVIGATION_TYPE.PAGER;
    this.showNavigation = true;
  }

  private setNavigationTypeNone() {
    this.navControls = NAVIGATION_TYPE.NONE;
    this.showNavigation = false;
  }

  private enableInfiniteScroll() {
    this.infScroll = true;
  }

  private enableOnDemandLoad() {
    this.onDemandLoad = true;
    this.showNavigation = true;
  }

  /**
   * Sets Navigation type for the list.
   * @param type
   */
  private onNavigationTypeChange(type: any) {
    this.resetNavigation();
    switch (type) {
      case NAVIGATION_TYPE.BASIC:
        this.enableBasicNavigation();
        break;
      case NAVIGATION_TYPE.INLINE:
        this.enableInlineNavigation();
        break;
      case NAVIGATION_TYPE.ADVANCED:
      case NAVIGATION_TYPE.CLASSIC:
        this.enableClassicNavigation();
        break;
      case NAVIGATION_TYPE.PAGER:
        this.enablePagerNavigation();
        break;
      case NAVIGATION_TYPE.NONE:
        this.setNavigationTypeNone();
        break;
      case NAVIGATION_TYPE.SCROLL:
        this.enableInfiniteScroll();
        break;
      case NAVIGATION_TYPE.ONDEMAND:
        this.enableOnDemandLoad();
        break;
    }
  }

  override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'dataset') {
      this.handlePageSizeDisplay(nv.split('.')[1]);
      if (!nv && this.binddatasource && !this.datasource) {
        return;
      }
      // this.onDataSetChange(nv);
    } else if (key === 'datasource') {
      if (this.dataset) {
        // this.onDataSetChange(this.dataset);
      }
    } else if (key === 'navigation') {
      // Support for older projects where navigation type was advanced instead of classic
      if (nv === 'Advanced') {
        this.navigation = 'Classic';
        return;
      }
      switchClass(this.nativeElement, nv, ov);
      this.onNavigationTypeChange(nv);
      if (this.dataNavigator) {
        this.dataNavigator.navigationClass = this.paginationclass;
      }
      this.widgetProps['allowpagesizechange'].show = !includes(['None', 'On-Demand', 'Scroll', 'Inline'], nv);
      this.widgetProps['pagesizeoptions'].show  = this.widgetProps['allowpagesizechange'].show && this.widgetProps['allowpagesizechange'].value;

    } else if (key === 'paginationclass') {
      if (this.dataNavigator) {
        // Adding setTimeout because in pagination component updateNavSize method is overriding navigationclass
        setTimeout(() => this.dataNavigator.navigationClass = nv);
      }
    } else if (key === 'itemsperrow') {
      setListClass(this);
    } else if (key === 'groupby'){
      this.liveWidgetUtils.showOrHideMatchProperty(this, this.widgetProps);
    } else if (key === 'match') {
      this.widgetProps['dateformat'].show = includes(['day', 'hour', 'month', 'week'], nv);
    } else if(key === 'deferload' && this.binddatasource) {
      this.widgetProps['deferload'].show = true;
    } else if (key === 'allowpagesizechange') {
      this.widgetProps['allowpagesizechange'].value =  nv;
      this.widgetProps['pagesizeoptions'].show = nv && this.widgetProps['allowpagesizechange']?.show;
    }else if (key === 'pagesizeoptions') {
      this.widgetProps['pagesizeoptions'].value =  nv;
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }

  setWidgetId(liItemElement: any) {
    let widgetId = $(liItemElement).attr('widgetid');
    if (!widgetId) {
      let markupManager = runtimeEventManager.getService('markupManager');
      let listId = this.getNativeElement().getAttribute('widget-id');
      let listItem = markupManager.markup?.find('[widget-id="' + listId + '"]')?.find('wm-listtemplate');
      if (listItem?.length) {
        const listItemId = listItem.attr('widget-id') || listItem.attr('widgetid');
        if (listItemId) {
          $(liItemElement).attr('widgetid', listItemId).attr('widget-id', listItemId);
          $(liItemElement).attr('widgettype', 'wm-listtemplate');
          $(liItemElement).attr('name', listItem.attr('name'));
        }
      }
    }
  }
  handlePageSizeDisplay(variableName:string) {
    let wp:any= this.widgetProps
    let variableObj = this.liveWidgetUtils.variableService.getVariableByName(variableName);
    if (variableObj) {
      const registry = getWidgetRegistry();
      let widgetName                      = split(this.$attrs.get('dataset.bind'), '.')[1],
        isBoundToLiveVariable           = (variableObj.category === 'wm.LiveVariable'),
        isBoundToWidget                 = startsWith(this.$attrs.get('dataset.bind'), 'Widgets.'),
        isBoundToFilter                 = get(registry, widgetName + '._widgettype') === 'wm-livefilter',
        isBoundToQueryServiceVariable   = (variableObj.category === 'wm.ServiceVariable') && (variableObj.serviceType === 'DataService') && (variableObj.controller === 'QueryExecution');
      // Make the "pageSize" property hidden so that no editing is possible for live and query service variables
      wp.pagesize.show =!(isBoundToLiveVariable || isBoundToQueryServiceVariable) || (isBoundToWidget ? !isBoundToFilter : false);

    }
  }

  getWidgets() {}
}
